// @mui
import { useTheme } from '@mui/material/styles';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
// theme
import { bgBlur } from 'theme/css';
// routes
// hooks
import { useOffSetTop } from 'hooks/use-off-set-top';
// components
import Logo from 'components/logo';
//
import { Stack } from '@mui/material';
import HeaderShadow from './header-shadow';
import { HEADER } from '../config-layout';
import AccountPopover from './account-popover';

// ----------------------------------------------------------------------

export default function HeaderSimple() {
    const theme = useTheme();

    const offsetTop = useOffSetTop(HEADER.H_DESKTOP);

    return (
        <AppBar>
            <Toolbar
                sx={{
                    justifyContent: 'space-between',
                    height: {
                        xs: HEADER.H_MOBILE,
                        md: HEADER.H_DESKTOP
                    },
                    transition: theme.transitions.create(['height'], {
                        easing: theme.transitions.easing.easeInOut,
                        duration: theme.transitions.duration.shorter
                    }),
                    ...(offsetTop && {
                        ...bgBlur({
                            color: theme.palette.background.default
                        }),
                        height: {
                            md: HEADER.H_DESKTOP_OFFSET
                        }
                    })
                }}
            >
                <Logo />

                <Stack direction="row" alignItems="center" spacing={1}>
                    <AccountPopover />
                </Stack>
            </Toolbar>

            {offsetTop && <HeaderShadow />}
        </AppBar>
    );
}
